import { render, staticRenderFns } from "./StageDetail.vue?vue&type=template&id=379c4c29&scoped=true&"
import script from "./StageDetail.vue?vue&type=script&lang=js&"
export * from "./StageDetail.vue?vue&type=script&lang=js&"
import style0 from "./StageDetail.vue?vue&type=style&index=0&id=379c4c29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c4c29",
  null
  
)

export default component.exports